import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import styled, { css } from 'styled-components'
import '../../node_modules/slick-carousel/slick/slick.css'
import '../../node_modules/slick-carousel/slick/slick-theme.css'
import './Project.css'

import Text from '../components/Text'
import Footer from '../components/Footer'

const Colored = styled.div`
  a {
    ${props => props.color && css`
      color: ${props.color};
    `}
  }
`

const Prev = (props) => (
  <svg className='arrows' onClick={props.onClick} version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='23.947px' height='45.297px' viewBox='0 0 23.947 45.297' enableBackground='new 0 0 23.947 45.297' space='preserve'>
    <polygon fill={props.color || '#545352'} points='22.648,45.297 0,22.648 22.65,0 23.947,1.297 2.594,22.648 23.945,44' />
  </svg>
)

const Next = (props) => (
  <svg className='arrows' onClick={props.onClick} version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='23.947px' height='45.297px' viewBox='0 0 23.947 45.297' enableBackground='new 0 0 23.947 45.297' space='preserve'>
    <polygon fill={props.color || '#545352'} points='1.299,0 23.947,22.648 1.297,45.297 0,44 21.354,22.648 0.002,1.297' />
  </svg>
)

class Project extends Component {
  constructor (props) {
    super(props)

    this.state = {
      project: {},
      nextProject: ''
    }
  }

  componentWillMount () {
    return this.props.changeHeaderColors('#545352', '#efeae6')
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.project.name && this.state.nextProject.toLowerCase() !== nextProps.match.params.name.replace('%3F', '?').toLowerCase()) return false
    if (Object.keys(nextProps.projects).length === 0) return false

    const years = Object.keys(nextProps.projects)

    for (let i = 0; i < years.length; i++) {
      for (let j = 0; j < nextProps.projects[years[i]].length; j++) {
        if (nextProps.projects[years[i]][j].name.toLowerCase() === nextProps.match.params.name.replace('%3F', '?').toLowerCase()) {
          this.setState({ project: nextProps.projects[years[i]][j] })
          this.props.changeHeaderColors(nextProps.projects[years[i]][j].textColor, nextProps.projects[years[i]][j].backgroundColor)
          if (nextProps.projects[years[i]][j + 1]) {
            this.setState({ nextProject: nextProps.projects[years[i]][j + 1].name })
          } else if (nextProps.projects[years[i - 1]] && nextProps.projects[years[i - 1]][0]) {
            this.setState({ nextProject: nextProps.projects[years[i - 1]][0].name })
          } else if (nextProps.projects[years[years.length - 1]] && nextProps.projects[years[years.length - 1]][0]) {
            this.setState({ nextProject: nextProps.projects[years[years.length - 1]][0].name })
          }
          i = years.length
          break
        }
      }
    }
    return true
  }

  render () {
    const settings = {
      className: 'slide',
      dots: false,
      infinite: true,
      nextArrow: <Next color={this.state.project.textColor} />,
      prevArrow: <Prev color={this.state.project.textColor} />
    }

    let images = []
    if (this.state.project.slider) {
      images = this.state.project.slider.map((img) => {
        const split = img.split('.')
        return (
          <div className='carousel' key={img}>{(split[split.length - 1] !== 'mp4') ? <img src={img} alt='img' /> : <video controls loop><source src={img} type='video/mp4' />Your browser does not support HTML5 video.</video>}</div>
        )
      })
    }

    return (
      <div className='content columns'>
        <div className='sidebar'>
          <div className='sidebarContent' style={{ borderRight: `0.2rem solid ${this.state.project.borderColor || '#545352'}` }}>
            <div className='backHome'>
              <Link to='/' style={{ color: `${this.state.project.textColor || '#545352'}` }}>
                <div>
                  <div>
                    Back
                    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='42.666px' height='15.87px' viewBox='0 0 42.666 15.87' enableBackground='new 0 0 42.666 15.87' space='preserve'>
                      <polygon fill={this.state.project.textColor || '#545352'} points='0,7.935 7.934,0 10.178,0 3.037,7.142 11.869,7.142 42.666,7.142 42.666,8.729 11.869,8.729 3.037,8.729 10.178,15.87 7.934,15.87' />
                    </svg>
                  </div>
                  <div>Home</div>
                </div>
              </Link>
            </div>
            <div className='nextProject'>
              <Link to={`/project/${this.state.nextProject.replace('?', '%3F')}`} /* div onClick={() => this.nextProject()} */ /* Link to={`/project/${this.state.nextProject}`} */ style={{ color: `${this.state.project.textColor || '#545352'}` }}>
                <div>
                  <div>
                    Next
                    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='42.666px' height='15.87px' viewBox='0 0 42.666 15.87' enableBackground='new 0 0 42.666 15.87' space='preserve'>
                      <polygon fill={this.state.project.textColor || '#545352'} points='42.666,7.936 34.732,15.87 32.488,15.87 39.629,8.729 30.797,8.729 0,8.729 0,7.142 30.797,7.142 39.629,7.142 32.488,0 34.732,0' />
                    </svg>
                  </div>
                  <div>Project</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div id='project' className='column project'>
          <div className='max'>
            <div className='wrap'>
              <Footer margin='1rem 0'>{this.state.project.category}</Footer>
              <Text margin='0'>{this.state.project.name}</Text>
              <hr style={{ borderColor: this.state.project.borderColor || '#545352' }} />
            </div>
            {(images.length !== 0) ? <Slider {...settings}>
              {images}
            </Slider> : ''}
            <div className='wrap'>
              <hr style={{ borderColor: this.state.project.borderColor || '#545352' }} />
              <Text>
                <div dangerouslySetInnerHTML={{ __html: this.state.project.description }} />
              </Text>
              <hr style={{ borderColor: this.state.project.borderColor || '#545352' }} />
              <Footer>
                <Colored color={this.state.project.textColor} dangerouslySetInnerHTML={{ __html: this.state.project.footer }} />
              </Footer>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Project



// WEBPACK FOOTER //
// ./src/pages/Project.js